<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <Table stripe :columns="tdata.col_data" :data="tdata.current_data" :loading="tdata.loading">
        <template slot-scope="{row}" slot="status">{{getStatusName(row.isenabled)}}</template>
        <template slot-scope="{row}" slot="opt">
          <Button size="small" @click="setEnableStatus(row)">{{row.isenabled==1?"禁用":"启用"}}</Button>
          <Button size="small" @click="roleSet(row)" style="margin-left:10px">角色</Button>
        </template>
      </Table>

      <Modal v-model="roleSetModal.modal" title="用户角色设置">
        <Checkbox
          v-for="item in roleSetModal.singleUserRoleTable"
          :key="item.roleid"
          :label="item.rolename"
          v-model="item.has"
        >{{item.rolename}}</Checkbox>
        <div slot="footer">
          <Button type="text" size="large" @click="roleSetCancel">取消</Button>
          <Button type="primary" size="large" @click="roleSetConfirm">确定</Button>
        </div>
      </Modal>
    </Card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roleSetModal: {
        modal: false,
        currentUserGuid: "",
        singleUserRoleTable: [],
      },
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "用户姓名",
            key: "displayname",
          },
          {
            title: "登录名",
            key: "loginid",
          },
          // {
          //   title: "登录时间",
          //   key: "lastlogindate"
          // },
          // {
          //   title: "登录次数",
          //   key: "logintimes"
          // },
          {
            title: "账号状态",
            slot: "status",
          },
          {
            title: "操作",
            slot: "opt",
          },
        ],
      },
    };
  },
  methods: {
    //角色设置
    roleSet(row) {
      let _this = this;
      _this.roleSetModal.currentUserGuid = row.userguid;
      this.$http.get({
        method: "/base/userrole/getsingleuserroletable",
        params: {
          userguid: row.userguid,
        },
        success: function (data) {
          _this.roleSetModal.modal = true;
          _this.roleSetModal.singleUserRoleTable = data;
        },
      });
    },
    roleSetCancel() {
      this.roleSetModal.modal = false;
    },
    roleSetConfirm() {
      let _this = this;
      let roles = [];
      for (let i = 0; i < this.roleSetModal.singleUserRoleTable.length; i++) {
        if (this.roleSetModal.singleUserRoleTable[i].has) {
          roles.push(this.roleSetModal.singleUserRoleTable[i].roleid);
        }
      }
      this.$http.post({
        method: "/base/userrole/setuserrole",
        params: {
          userguid: this.roleSetModal.currentUserGuid,
          roles: roles,
        },
        success: function (data) {
          _this.roleSetModal.modal = false;
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    getList() {
      let _this = this;
      this.$http.get({
        method: "/base/user/list",
        params: null,
        success: function (data) {
          _this.tdata.current_data = data;
        },
        failure(code, msg) {},
      });
    },
    getStatusName(isenabled) {
      if (isenabled == 0) {
        return "禁用";
      } else if (isenabled == 1) {
        return "正常";
      } else if (isenabled == 2) {
        return "待审核";
      } else {
        return "";
      }
    },
    setEnableStatus(row) {
      let _this = this;
      let passenable;
      if (row.isenabled == 0 || row.isenabled == 2) {
        passenable = 1;
      } else {
        passenable = 0;
      }
      this.$http.post({
        method: "/base/user/setenable",
        params: {
          userguid: row.userguid,
          isenabled: passenable,
        },
        success: function (data) {
          _this.getList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    setRole(row) {
      this.roleSetModal.modal = true;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>